export default "__VITE_ASSET__DsrIZbdt__"